export const C360Ability = {
  See: 'see',
  SeeEmailInTheFooter: 'see.footer.email',
  AlwaysSeeSwitchProductDrawer: 'see.product-drawer.always',
  Interact: 'Interact',
};
